// extracted by mini-css-extract-plugin
module.exports = {"verticallyCenter":"verticallyCenter--2Nh4qHma","horizontalCenter":"horizontalCenter--3qI2YPtk","title":"title--2RunVvy9"};